// Registry de bundles `templateVersion` → UI da ficha.
// Espelha `getInspectionTemplate` / `CURRENT_INSPECTION_TEMPLATE_VERSION` do back.
// Decisão: docs/prd/inspection/inspection-implementation-decisions.md I2.
//
// Versão nova (`inspection-v2`, `inspection-v59`, …) = pasta nova + uma linha
// aqui. O modal e a camada HTTP não são reabertos.

import type { InspectionFormBundle } from "./inspection-form-bundle";
import { INSPECTION_FORM_V1, inspectionFormBundleV1 } from "./inspection-v1";

/** Versão corrente registrada nesta build (espelha o CURRENT do back). */
export const CURRENT_INSPECTION_FORM_VERSION = INSPECTION_FORM_V1;

const INSPECTION_FORM_BUNDLES: Record<string, InspectionFormBundle> = {
  [INSPECTION_FORM_V1]: inspectionFormBundleV1,
  // inspection-v2: importar `inspectionFormBundleV2` e registrar aqui.
};

/**
 * Bundle da versão; `null` quando a `templateVersion` não é registrada nesta
 * build. Sem fallback para v1 — renderizar a ficha errada é pior que recusar.
 */
export function getInspectionFormBundle(
  version: string,
): InspectionFormBundle | null {
  return INSPECTION_FORM_BUNDLES[version] ?? null;
}

export { INSPECTION_FORM_V1 };
export type {
  InspectionFormBundle,
  InspectionFormBundleProps,
  InspectionFormMode,
} from "./inspection-form-bundle";
